export default __webpack_public_path__ + "static/media/avatarSF.90286e02.png";